export const PKG_NAME = "@hpcc-js/observable-md";
export const PKG_VERSION = "2.54.18";
export const BUILD_VERSION = "2.104.41";
